<template>
  <div class="sn-f-b-s homepage">
    <sn-navigator id="YJYY" :initial="perpetual.FUNCTION_ID_YJYY"></sn-navigator>
    <div class="sn-f-1 sn-f-col-b-s homepage-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_YJYY)
      }]"></sn-breadcrumb>
      <div class="sn-f-b-e sn-title operate">
        <div class="sn-f-s-c">
          <div class="sn-f-c-c sn-pointer title-caption"
          :class="{'interaction': $route.path === '/mta/homepage/ap'}" @click="navigateUrl('/mta/homepage/ap');">
            {{ $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_YJYY) }}
          </div>
          <div class="sn-f-c-c sn-pointer title-caption"
          :class="{'interaction': $route.path === '/mta/homepage/record'}" @click="navigateUrl('/mta/homepage/record');">
            预约记录
          </div>
        </div>
      </div>
      <div class="sn-f-1 homepage-sub">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  mixins: [HomepageMixin],
  watch: {
    '$route.path': {
      handler: function(path) {
        let title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_YJYY);
        if (path === '/mta/homepage/record') {
          title = '预约记录';
        }
        document.title = title;
        this.$route.meta.title = title;
      },
      immediate: true
    }
  },
  methods: {
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === this.$route.path) return false;
      if (url === '') {
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.homepage {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    height: 100%;

    .homepage-sub {
      overflow: hidden;
      width: 100%;
      padding: 0 20px 20px;
    }
  }
}
</style>
